import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import SideBarNew from "../../SideBarNew";
import TopBarNew from "../../TopBarNew";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import AppConstants from "../../AppConstants";
import { activesubscription } from "../../redux";
import { getActiveTeam } from "../../Teams";
import {
  checkSubscriptionAndStorage,
  addUserAnalytic,
  updateOutTime,
} from "../../ReusableComponents/reusableFunctions";
import TableView from "../../ReusableComponents/TableView/TableView.js";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import Search from "../../Icon/Search.png";
import * as API from "../../api.js";
import InstallationStatus from "./ReusableComp/InstallationStatus.js";
import Monitoring from "./ReusableComp/Monitoring.js";
import DoughnutCard from "./ReusableComp/DoughnutCard.js";

const ProgressDetails = (props) => {
  const [user, setUser] = useState({ username: "Guest" });
  const [type, setType] = useState("viewer");
  const [sidebarMode, setSidebarMode] = useState("shrunk");
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [projects, setProjects] = useState([]);
  const [counts, setCounts] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [tableState, setTableState] = useState({
    pageSize: 10,
    pageNumber: 1,
    orderBy: undefined,
    orderType: undefined,
  });
  const location = useLocation();
  const history = useHistory();
  const { rowData, status, projectName, planName, id } = location?.state || {};

  const sidebarConfigurations = {
    options: showBackIcon
      ? [
          { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
          { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  const topbarConfigurations = {
    options: showBackIcon
      ? [
          { icon: MenuIcon, text: "Dashboard", path: "/picstork/dashboard" },
          {
            icon: MenuIcon,
            text: "Total Projects",
            path: "/picstork/total-projects",
          },
          {
            icon: MenuIcon,
            text: projectName,
            path: "/picstork/total-towers",
            rowData : { id: id, project_name: projectName }
          },
          {
            icon: MenuIcon,
            text: planName,
            path: "/picstork/progress-details",
            state: {
              rowData: rowData,
              status: status,
              projectName: projectName,
              id: id,
              planName: planName,
            },
          },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  useEffect(() => {
    return () => {
      updateOutTime(rowData?.id);
    };
  }, [rowData]);

  const items = [
    { label: "Pits", value: rowData?.includes("pits") ? "Yes" : "No" },
    {
      label: "Base Plate",
      value: rowData?.includes("baseplate") ? "Yes" : "No",
    },
    {
      label: "Tower Erection",
      value: rowData?.includes("towerErection") ? "Yes" : "No",
    },
    {
      label: "Stringing",
      value: rowData?.includes("stringing") ? "Yes" : "No",
    },
  ];

  const defectsData = [
    { label: "Add_barbed_wire", count: 6 },
    { label: "Clamps", count: 4 },
    { label: "Insulator Damage", count: 5 },
    { label: "Broken Conductor", count: 8 },
    { label: "Corrosion", count: 3 },
    { label: "Loose Hardware", count: 7 },
    { label: "Vegetation Encroachment", count: 4 },
    { label: "Foundation Cracks", count: 8 },
    { label: "Guy Wire Issues", count: 8 },
    { label: "Crossarm Damage", count: 2 },
    { label: "Bird Nesting", count: 1 },
    { label: "Pollution Deposit", count: 9 },
  ];

  return (
    <div className="wrapper">
      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode((prev) => (prev === "shrunk" ? "expanded" : "shrunk"))
        }
      />

      <div className="right-content" style={{ backgroundColor: "#EAEDF0" }}>
        <TopBarNew config={topbarConfigurations} />

        <div style={{ padding: "20px" }}>
          <h2
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#18242D",
            }}
          >
            {planName} Progress Details
          </h2>
        </div>
        <InstallationStatus items={items} status={status} />
        <Monitoring />
        <DoughnutCard data={defectsData} title="Defects" />
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgressDetails);
